/* src/components/Toolbar/components/Contents.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	assign,
	attr,
	binding_callbacks,
	check_outros,
	component_subscribe,
	construct_svelte_component,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	get_spread_object,
	get_spread_update,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_store_value,
	set_style,
	space,
	src_url_equal,
	subscribe,
	text as text_1,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { applianceShapes, shapesIcon, shapesIconActive } from "./constants";
import { writable } from "svelte/store";
import { scrollHeight } from "../../../actions/height";
import { scrollTop } from "../../../actions/scroll";
import { clamp } from "../../helpers";
import { i18n } from "./constants";
import { apps } from "../../../behaviors";
import { tooltip } from "./helper";
import Icons from "../../Icons";
import Button from "../../Button";
import StrokeWidth from "./StrokeWidth.svelte";
import StrokeColor from "./StrokeColor.svelte";
import TextColor from "./TextColor.svelte";
import Shapes from "./Shapes.svelte";
import { tippy_hide_all } from "../../../actions/tippy";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[42] = list[i];
	const constants_0 = /*netless_app*/ child_ctx[42];
	child_ctx[43] = constants_0.icon;
	child_ctx[44] = constants_0.label;
	child_ctx[45] = constants_0.kind;
	child_ctx[46] = constants_0.onClick;
	const constants_1 = /*$status*/ child_ctx[20] && /*$status*/ child_ctx[20][/*kind*/ child_ctx[45]];
	child_ctx[47] = constants_1;

	const constants_2 = function func() {
		return /*func*/ ctx[38](/*onClick*/ child_ctx[46]);
	};

	child_ctx[48] = constants_2;
	return child_ctx;
}

// (95:0) {#if scrollable}
function create_if_block_8(ctx) {
	let button;
	let current;
	const button_spread_levels = [{ class: "scroll-up" }, /*btn_props*/ ctx[15]];

	let button_props = {
		$$slots: { default: [create_default_slot_9] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button_spread_levels.length; i += 1) {
		button_props = assign(button_props, button_spread_levels[i]);
	}

	button = new Button({ props: button_props });
	button.$on("click", /*scroll_up*/ ctx[22]);

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = (dirty[0] & /*btn_props*/ 32768)
			? get_spread_update(button_spread_levels, [button_spread_levels[0], get_spread_object(/*btn_props*/ ctx[15])])
			: {};

			if (dirty[0] & /*theme*/ 2 | dirty[1] & /*$$scope*/ 1048576) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (96:2) <Button class="scroll-up" {...btn_props} on:click={scroll_up}>
function create_default_slot_9(ctx) {
	let icons_up;
	let current;
	icons_up = new Icons.Up({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_up.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_up, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_up_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_up_changes.theme = /*theme*/ ctx[1];
			icons_up.$set(icons_up_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_up.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_up.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_up, detaching);
		}
	};
}

// (104:4) {:else}
function create_else_block_5(ctx) {
	let icons_click;
	let current;
	icons_click = new Icons.Click({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_click.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_click, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_click_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_click_changes.theme = /*theme*/ ctx[1];
			icons_click.$set(icons_click_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_click.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_click.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_click, detaching);
		}
	};
}

// (102:4) {#if appliance === "clicker"}
function create_if_block_7(ctx) {
	let icons_clickfilled;
	let current;

	icons_clickfilled = new Icons.ClickFilled({
			props: { theme: /*theme*/ ctx[1], active: true }
		});

	return {
		c() {
			create_component(icons_clickfilled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_clickfilled, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_clickfilled_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_clickfilled_changes.theme = /*theme*/ ctx[1];
			icons_clickfilled.$set(icons_clickfilled_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_clickfilled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_clickfilled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_clickfilled, detaching);
		}
	};
}

// (101:2) <Button class="clicker" {...btn_props} on:click={clicker} content={c.clicker}>
function create_default_slot_8(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_7, create_else_block_5];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*appliance*/ ctx[8] === "clicker") return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (111:4) {:else}
function create_else_block_4(ctx) {
	let icons_selector;
	let current;
	icons_selector = new Icons.Selector({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_selector.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_selector, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_selector_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_selector_changes.theme = /*theme*/ ctx[1];
			icons_selector.$set(icons_selector_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_selector.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_selector.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_selector, detaching);
		}
	};
}

// (109:4) {#if appliance === "selector"}
function create_if_block_6(ctx) {
	let icons_selectorfilled;
	let current;

	icons_selectorfilled = new Icons.SelectorFilled({
			props: { theme: /*theme*/ ctx[1], active: true }
		});

	return {
		c() {
			create_component(icons_selectorfilled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_selectorfilled, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_selectorfilled_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_selectorfilled_changes.theme = /*theme*/ ctx[1];
			icons_selectorfilled.$set(icons_selectorfilled_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_selectorfilled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_selectorfilled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_selectorfilled, detaching);
		}
	};
}

// (108:2) <Button class="selector" {...btn_props} on:click={selector} content={c.selector}>
function create_default_slot_7(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_6, create_else_block_4];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*appliance*/ ctx[8] === "selector") return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (118:4) {:else}
function create_else_block_3(ctx) {
	let icons_pencil;
	let current;
	icons_pencil = new Icons.Pencil({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_pencil.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_pencil, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_pencil_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_pencil_changes.theme = /*theme*/ ctx[1];
			icons_pencil.$set(icons_pencil_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_pencil.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_pencil.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_pencil, detaching);
		}
	};
}

// (116:4) {#if appliance === "pencil"}
function create_if_block_5(ctx) {
	let icons_pencilfilled;
	let current;

	icons_pencilfilled = new Icons.PencilFilled({
			props: { theme: /*theme*/ ctx[1], active: true }
		});

	return {
		c() {
			create_component(icons_pencilfilled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_pencilfilled, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_pencilfilled_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_pencilfilled_changes.theme = /*theme*/ ctx[1];
			icons_pencilfilled.$set(icons_pencilfilled_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_pencilfilled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_pencilfilled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_pencilfilled, detaching);
		}
	};
}

// (115:2) <Button class="pencil" {...btn_props} on:click={pencil} content={c.pencil} menu={pencil_panel}>
function create_default_slot_6(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_5, create_else_block_3];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*appliance*/ ctx[8] === "pencil") return 0;
		return 1;
	}

	current_block_type_index = select_block_type_2(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (125:4) {:else}
function create_else_block_2(ctx) {
	let icons_text;
	let current;
	icons_text = new Icons.Text({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_text.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_text, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_text_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_text_changes.theme = /*theme*/ ctx[1];
			icons_text.$set(icons_text_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_text.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_text.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_text, detaching);
		}
	};
}

// (123:4) {#if appliance === "text"}
function create_if_block_4(ctx) {
	let icons_textfilled;
	let current;

	icons_textfilled = new Icons.TextFilled({
			props: { theme: /*theme*/ ctx[1], active: true }
		});

	return {
		c() {
			create_component(icons_textfilled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_textfilled, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_textfilled_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_textfilled_changes.theme = /*theme*/ ctx[1];
			icons_textfilled.$set(icons_textfilled_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_textfilled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_textfilled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_textfilled, detaching);
		}
	};
}

// (122:2) <Button class="text" {...btn_props} on:click={text} content={c.text} menu={text_panel}>
function create_default_slot_5(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_4, create_else_block_2];
	const if_blocks = [];

	function select_block_type_3(ctx, dirty) {
		if (/*appliance*/ ctx[8] === "text") return 0;
		return 1;
	}

	current_block_type_index = select_block_type_3(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_3(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (132:4) {:else}
function create_else_block_1(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = shapesIcon[/*last_shape*/ ctx[10]];

	function switch_props(ctx) {
		return { props: { theme: /*theme*/ ctx[1] } };
	}

	if (switch_value) {
		switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) mount_component(switch_instance, target, anchor);
			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};
			if (dirty[0] & /*theme*/ 2) switch_instance_changes.theme = /*theme*/ ctx[1];

			if (switch_value !== (switch_value = shapesIcon[/*last_shape*/ ctx[10]])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (130:4) {#if appliance === last_shape || (appliance === "shape" && shape === last_shape)}
function create_if_block_3(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = shapesIconActive[/*last_shape*/ ctx[10]];

	function switch_props(ctx) {
		return {
			props: { theme: /*theme*/ ctx[1], active: true }
		};
	}

	if (switch_value) {
		switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) mount_component(switch_instance, target, anchor);
			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};
			if (dirty[0] & /*theme*/ 2) switch_instance_changes.theme = /*theme*/ ctx[1];

			if (switch_value !== (switch_value = shapesIconActive[/*last_shape*/ ctx[10]])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (129:2) <Button class="shapes" {...btn_props} on:click={select_last_shape} content={t.shapes} menu={shapes_panel}>
function create_default_slot_4(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_3, create_else_block_1];
	const if_blocks = [];

	function select_block_type_4(ctx, dirty) {
		if (/*appliance*/ ctx[8] === /*last_shape*/ ctx[10] || /*appliance*/ ctx[8] === "shape" && /*shape*/ ctx[7] === /*last_shape*/ ctx[10]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_4(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_4(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (139:4) {:else}
function create_else_block(ctx) {
	let icons_eraser;
	let current;
	icons_eraser = new Icons.Eraser({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_eraser.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_eraser, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_eraser_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_eraser_changes.theme = /*theme*/ ctx[1];
			icons_eraser.$set(icons_eraser_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_eraser.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_eraser.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_eraser, detaching);
		}
	};
}

// (137:4) {#if appliance === "eraser"}
function create_if_block_2(ctx) {
	let icons_eraserfilled;
	let current;

	icons_eraserfilled = new Icons.EraserFilled({
			props: { theme: /*theme*/ ctx[1], active: true }
		});

	return {
		c() {
			create_component(icons_eraserfilled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_eraserfilled, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_eraserfilled_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_eraserfilled_changes.theme = /*theme*/ ctx[1];
			icons_eraserfilled.$set(icons_eraserfilled_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_eraserfilled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_eraserfilled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_eraserfilled, detaching);
		}
	};
}

// (136:2) <Button class="eraser" {...btn_props} on:click={eraser} content={c.eraser}>
function create_default_slot_3(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_2, create_else_block];
	const if_blocks = [];

	function select_block_type_5(ctx, dirty) {
		if (/*appliance*/ ctx[8] === "eraser") return 0;
		return 1;
	}

	current_block_type_index = select_block_type_5(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_5(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (143:2) <Button class="clear" {...btn_props} on:click={clear} content={t.clear}>
function create_default_slot_2(ctx) {
	let icons_clear;
	let current;
	icons_clear = new Icons.Clear({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_clear.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_clear, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_clear_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_clear_changes.theme = /*theme*/ ctx[1];
			icons_clear.$set(icons_clear_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_clear.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_clear.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_clear, detaching);
		}
	};
}

// (146:2) {#if !hide_apps}
function create_if_block_1(ctx) {
	let button;
	let current;

	const button_spread_levels = [
		{ class: "apps" },
		/*btn_props*/ ctx[15],
		{ content: /*t*/ ctx[9].apps },
		{ menu: /*apps_panel*/ ctx[14] },
		{ menu_placement: "right-end" }
	];

	let button_props = {
		$$slots: { default: [create_default_slot_1] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button_spread_levels.length; i += 1) {
		button_props = assign(button_props, button_spread_levels[i]);
	}

	button = new Button({ props: button_props });

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = (dirty[0] & /*btn_props, t, apps_panel*/ 49664)
			? get_spread_update(button_spread_levels, [
					button_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*t*/ 512 && { content: /*t*/ ctx[9].apps },
					dirty[0] & /*apps_panel*/ 16384 && { menu: /*apps_panel*/ ctx[14] },
					button_spread_levels[4]
				])
			: {};

			if (dirty[0] & /*theme*/ 2 | dirty[1] & /*$$scope*/ 1048576) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (147:4) <Button class="apps" {...btn_props} content={t.apps} menu={apps_panel} menu_placement="right-end">
function create_default_slot_1(ctx) {
	let icons_apps;
	let current;
	icons_apps = new Icons.Apps({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_apps.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_apps, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_apps_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_apps_changes.theme = /*theme*/ ctx[1];
			icons_apps.$set(icons_apps_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_apps.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_apps.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_apps, detaching);
		}
	};
}

// (152:0) {#if scrollable}
function create_if_block(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				class: "scroll-down",
				name,
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*scroll_down*/ ctx[23]);

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};
			if (dirty[0] & /*theme*/ 2) button_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) button_changes.disabled = /*disabled*/ ctx[3];

			if (dirty[0] & /*theme*/ 2 | dirty[1] & /*$$scope*/ 1048576) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (153:2) <Button class="scroll-down" {name} {theme} {disabled} on:click={scroll_down}>
function create_default_slot(ctx) {
	let icons_down;
	let current;
	icons_down = new Icons.Down({ props: { theme: /*theme*/ ctx[1] } });

	return {
		c() {
			create_component(icons_down.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_down, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_down_changes = {};
			if (dirty[0] & /*theme*/ 2) icons_down_changes.theme = /*theme*/ ctx[1];
			icons_down.$set(icons_down_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_down.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_down.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_down, detaching);
		}
	};
}

// (175:4) {#each $apps as netless_app}
function create_each_block(ctx) {
	let button;
	let img;
	let img_class_value;
	let img_src_value;
	let img_alt_value;
	let img_title_value;
	let t0;
	let span;
	let t1_value = /*label*/ ctx[44] + "";
	let t1;
	let span_class_value;
	let t2;
	let button_class_value;
	let button_title_value;
	let button_data_app_kind_value;
	let button_disabled_value;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			img = element("img");
			t0 = space();
			span = element("span");
			t1 = text_1(t1_value);
			t2 = space();
			attr(img, "class", img_class_value = "" + (name + "-app-btn-icon " + /*theme*/ ctx[1]));
			if (!src_url_equal(img.src, img_src_value = /*icon*/ ctx[43])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*kind*/ ctx[45]);
			attr(img, "title", img_title_value = /*label*/ ctx[44]);
			attr(span, "class", span_class_value = "" + (name + "-app-btn-text " + /*theme*/ ctx[1]));
			attr(button, "class", button_class_value = "" + (name + "-app-btn " + /*kind*/ ctx[45] + " " + /*theme*/ ctx[1]));

			attr(button, "title", button_title_value = /*label*/ ctx[44] + (/*state*/ ctx[47] && /*state*/ ctx[47].reason
			? ": " + /*state*/ ctx[47].reason
			: ""));

			attr(button, "data-app-kind", button_data_app_kind_value = /*netless_app*/ ctx[42].kind);
			button.disabled = button_disabled_value = /*state*/ ctx[47] && /*state*/ ctx[47].status !== "idle";
			toggle_class(button, "is-loading", /*state*/ ctx[47] && /*state*/ ctx[47].status === "loading");
			toggle_class(button, "is-failed", /*state*/ ctx[47] && /*state*/ ctx[47].status === "failed");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, img);
			append(button, t0);
			append(button, span);
			append(span, t1);
			append(button, t2);

			if (!mounted) {
				dispose = listen(button, "click", function () {
					if (is_function(/*on_click*/ ctx[48])) /*on_click*/ ctx[48].apply(this, arguments);
				});

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*theme*/ 2 && img_class_value !== (img_class_value = "" + (name + "-app-btn-icon " + /*theme*/ ctx[1]))) {
				attr(img, "class", img_class_value);
			}

			if (dirty[0] & /*$apps*/ 524288 && !src_url_equal(img.src, img_src_value = /*icon*/ ctx[43])) {
				attr(img, "src", img_src_value);
			}

			if (dirty[0] & /*$apps*/ 524288 && img_alt_value !== (img_alt_value = /*kind*/ ctx[45])) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty[0] & /*$apps*/ 524288 && img_title_value !== (img_title_value = /*label*/ ctx[44])) {
				attr(img, "title", img_title_value);
			}

			if (dirty[0] & /*$apps*/ 524288 && t1_value !== (t1_value = /*label*/ ctx[44] + "")) set_data(t1, t1_value);

			if (dirty[0] & /*theme*/ 2 && span_class_value !== (span_class_value = "" + (name + "-app-btn-text " + /*theme*/ ctx[1]))) {
				attr(span, "class", span_class_value);
			}

			if (dirty[0] & /*$apps, theme*/ 524290 && button_class_value !== (button_class_value = "" + (name + "-app-btn " + /*kind*/ ctx[45] + " " + /*theme*/ ctx[1]))) {
				attr(button, "class", button_class_value);
			}

			if (dirty[0] & /*$apps, $status*/ 1572864 && button_title_value !== (button_title_value = /*label*/ ctx[44] + (/*state*/ ctx[47] && /*state*/ ctx[47].reason
			? ": " + /*state*/ ctx[47].reason
			: ""))) {
				attr(button, "title", button_title_value);
			}

			if (dirty[0] & /*$apps*/ 524288 && button_data_app_kind_value !== (button_data_app_kind_value = /*netless_app*/ ctx[42].kind)) {
				attr(button, "data-app-kind", button_data_app_kind_value);
			}

			if (dirty[0] & /*$status, $apps*/ 1572864 && button_disabled_value !== (button_disabled_value = /*state*/ ctx[47] && /*state*/ ctx[47].status !== "idle")) {
				button.disabled = button_disabled_value;
			}

			if (dirty[0] & /*$apps, theme, $status, $apps*/ 1572866) {
				toggle_class(button, "is-loading", /*state*/ ctx[47] && /*state*/ ctx[47].status === "loading");
			}

			if (dirty[0] & /*$apps, theme, $status, $apps*/ 1572866) {
				toggle_class(button, "is-failed", /*state*/ ctx[47] && /*state*/ ctx[47].status === "failed");
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let div0;
	let button0;
	let t1;
	let button1;
	let t2;
	let button2;
	let t3;
	let button3;
	let t4;
	let button4;
	let t5;
	let button5;
	let t6;
	let button6;
	let t7;
	let div0_class_value;
	let scrollHeight_action;
	let scrollTop_action;
	let t8;
	let t9;
	let div8;
	let div2;
	let strokewidth0;
	let t10;
	let div1;
	let div1_class_value;
	let t11;
	let strokecolor0;
	let div2_class_value;
	let t12;
	let div3;
	let textcolor;
	let div3_class_value;
	let t13;
	let div6;
	let shapes;
	let t14;
	let div4;
	let div4_class_value;
	let t15;
	let strokewidth1;
	let t16;
	let div5;
	let div5_class_value;
	let t17;
	let strokecolor1;
	let div6_class_value;
	let t18;
	let div7;
	let div7_class_value;
	let div8_class_value;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*scrollable*/ ctx[5] && create_if_block_8(ctx);

	const button0_spread_levels = [
		{ class: "clicker" },
		/*btn_props*/ ctx[15],
		{ content: /*c*/ ctx[18].clicker }
	];

	let button0_props = {
		$$slots: { default: [create_default_slot_8] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button0_spread_levels.length; i += 1) {
		button0_props = assign(button0_props, button0_spread_levels[i]);
	}

	button0 = new Button({ props: button0_props });
	button0.$on("click", /*clicker*/ ctx[24]);

	const button1_spread_levels = [
		{ class: "selector" },
		/*btn_props*/ ctx[15],
		{ content: /*c*/ ctx[18].selector }
	];

	let button1_props = {
		$$slots: { default: [create_default_slot_7] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button1_spread_levels.length; i += 1) {
		button1_props = assign(button1_props, button1_spread_levels[i]);
	}

	button1 = new Button({ props: button1_props });
	button1.$on("click", /*selector*/ ctx[25]);

	const button2_spread_levels = [
		{ class: "pencil" },
		/*btn_props*/ ctx[15],
		{ content: /*c*/ ctx[18].pencil },
		{ menu: /*pencil_panel*/ ctx[11] }
	];

	let button2_props = {
		$$slots: { default: [create_default_slot_6] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button2_spread_levels.length; i += 1) {
		button2_props = assign(button2_props, button2_spread_levels[i]);
	}

	button2 = new Button({ props: button2_props });
	button2.$on("click", /*pencil*/ ctx[26]);

	const button3_spread_levels = [
		{ class: "text" },
		/*btn_props*/ ctx[15],
		{ content: /*c*/ ctx[18].text },
		{ menu: /*text_panel*/ ctx[12] }
	];

	let button3_props = {
		$$slots: { default: [create_default_slot_5] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button3_spread_levels.length; i += 1) {
		button3_props = assign(button3_props, button3_spread_levels[i]);
	}

	button3 = new Button({ props: button3_props });
	button3.$on("click", /*text*/ ctx[27]);

	const button4_spread_levels = [
		{ class: "shapes" },
		/*btn_props*/ ctx[15],
		{ content: /*t*/ ctx[9].shapes },
		{ menu: /*shapes_panel*/ ctx[13] }
	];

	let button4_props = {
		$$slots: { default: [create_default_slot_4] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button4_spread_levels.length; i += 1) {
		button4_props = assign(button4_props, button4_spread_levels[i]);
	}

	button4 = new Button({ props: button4_props });
	button4.$on("click", /*select_last_shape*/ ctx[28]);
	const button5_spread_levels = [{ class: "eraser" }, /*btn_props*/ ctx[15], { content: /*c*/ ctx[18].eraser }];

	let button5_props = {
		$$slots: { default: [create_default_slot_3] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button5_spread_levels.length; i += 1) {
		button5_props = assign(button5_props, button5_spread_levels[i]);
	}

	button5 = new Button({ props: button5_props });
	button5.$on("click", /*eraser*/ ctx[29]);
	const button6_spread_levels = [{ class: "clear" }, /*btn_props*/ ctx[15], { content: /*t*/ ctx[9].clear }];

	let button6_props = {
		$$slots: { default: [create_default_slot_2] },
		$$scope: { ctx }
	};

	for (let i = 0; i < button6_spread_levels.length; i += 1) {
		button6_props = assign(button6_props, button6_spread_levels[i]);
	}

	button6 = new Button({ props: button6_props });
	button6.$on("click", /*clear*/ ctx[30]);
	let if_block1 = !/*hide_apps*/ ctx[6] && create_if_block_1(ctx);
	let if_block2 = /*scrollable*/ ctx[5] && create_if_block(ctx);

	strokewidth0 = new StrokeWidth({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3]
			}
		});

	strokecolor0 = new StrokeColor({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3]
			}
		});

	textcolor = new TextColor({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3]
			}
		});

	shapes = new Shapes({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2],
				disabled: /*disabled*/ ctx[3]
			}
		});

	strokewidth1 = new StrokeWidth({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3]
			}
		});

	strokecolor1 = new StrokeColor({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				disabled: /*disabled*/ ctx[3]
			}
		});

	let each_value = /*$apps*/ ctx[19];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div0 = element("div");
			create_component(button0.$$.fragment);
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			create_component(button2.$$.fragment);
			t3 = space();
			create_component(button3.$$.fragment);
			t4 = space();
			create_component(button4.$$.fragment);
			t5 = space();
			create_component(button5.$$.fragment);
			t6 = space();
			create_component(button6.$$.fragment);
			t7 = space();
			if (if_block1) if_block1.c();
			t8 = space();
			if (if_block2) if_block2.c();
			t9 = space();
			div8 = element("div");
			div2 = element("div");
			create_component(strokewidth0.$$.fragment);
			t10 = space();
			div1 = element("div");
			t11 = space();
			create_component(strokecolor0.$$.fragment);
			t12 = space();
			div3 = element("div");
			create_component(textcolor.$$.fragment);
			t13 = space();
			div6 = element("div");
			create_component(shapes.$$.fragment);
			t14 = space();
			div4 = element("div");
			t15 = space();
			create_component(strokewidth1.$$.fragment);
			t16 = space();
			div5 = element("div");
			t17 = space();
			create_component(strokecolor1.$$.fragment);
			t18 = space();
			div7 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div0, "class", div0_class_value = "" + (name + "-scrollable"));
			toggle_class(div0, "scrollable", /*scrollable*/ ctx[5]);
			attr(div1, "class", div1_class_value = "" + (name + "-panel-divider"));
			attr(div2, "class", div2_class_value = "" + (name + "-panel pencil"));
			attr(div3, "class", div3_class_value = "" + (name + "-panel text"));
			attr(div4, "class", div4_class_value = "" + (name + "-panel-divider"));
			attr(div5, "class", div5_class_value = "" + (name + "-panel-divider"));
			attr(div6, "class", div6_class_value = "" + (name + "-panel shapes"));
			attr(div7, "class", div7_class_value = "" + (name + "-panel apps"));
			set_style(div7, "--n", /*$apps*/ ctx[19].length);
			attr(div8, "class", div8_class_value = "" + (name + "-panel-wrapper"));
			set_style(div8, "display", "none");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div0, anchor);
			mount_component(button0, div0, null);
			append(div0, t1);
			mount_component(button1, div0, null);
			append(div0, t2);
			mount_component(button2, div0, null);
			append(div0, t3);
			mount_component(button3, div0, null);
			append(div0, t4);
			mount_component(button4, div0, null);
			append(div0, t5);
			mount_component(button5, div0, null);
			append(div0, t6);
			mount_component(button6, div0, null);
			append(div0, t7);
			if (if_block1) if_block1.m(div0, null);
			insert(target, t8, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, t9, anchor);
			insert(target, div8, anchor);
			append(div8, div2);
			mount_component(strokewidth0, div2, null);
			append(div2, t10);
			append(div2, div1);
			append(div2, t11);
			mount_component(strokecolor0, div2, null);
			/*div2_binding*/ ctx[35](div2);
			append(div8, t12);
			append(div8, div3);
			mount_component(textcolor, div3, null);
			/*div3_binding*/ ctx[36](div3);
			append(div8, t13);
			append(div8, div6);
			mount_component(shapes, div6, null);
			append(div6, t14);
			append(div6, div4);
			append(div6, t15);
			mount_component(strokewidth1, div6, null);
			append(div6, t16);
			append(div6, div5);
			append(div6, t17);
			mount_component(strokecolor1, div6, null);
			/*div6_binding*/ ctx[37](div6);
			append(div8, t18);
			append(div8, div7);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div7, null);
			}

			/*div7_binding*/ ctx[39](div7);
			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(scrollHeight_action = scrollHeight.call(null, div0, /*scroll_height*/ ctx[4])),
					action_destroyer(scrollTop_action = scrollTop.call(null, div0, /*top*/ ctx[21]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*scrollable*/ ctx[5]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*scrollable*/ 32) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_8(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			const button0_changes = (dirty[0] & /*btn_props, c*/ 294912)
			? get_spread_update(button0_spread_levels, [
					button0_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*c*/ 262144 && { content: /*c*/ ctx[18].clicker }
				])
			: {};

			if (dirty[0] & /*theme, appliance*/ 258 | dirty[1] & /*$$scope*/ 1048576) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);

			const button1_changes = (dirty[0] & /*btn_props, c*/ 294912)
			? get_spread_update(button1_spread_levels, [
					button1_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*c*/ 262144 && { content: /*c*/ ctx[18].selector }
				])
			: {};

			if (dirty[0] & /*theme, appliance*/ 258 | dirty[1] & /*$$scope*/ 1048576) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);

			const button2_changes = (dirty[0] & /*btn_props, c, pencil_panel*/ 296960)
			? get_spread_update(button2_spread_levels, [
					button2_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*c*/ 262144 && { content: /*c*/ ctx[18].pencil },
					dirty[0] & /*pencil_panel*/ 2048 && { menu: /*pencil_panel*/ ctx[11] }
				])
			: {};

			if (dirty[0] & /*theme, appliance*/ 258 | dirty[1] & /*$$scope*/ 1048576) {
				button2_changes.$$scope = { dirty, ctx };
			}

			button2.$set(button2_changes);

			const button3_changes = (dirty[0] & /*btn_props, c, text_panel*/ 299008)
			? get_spread_update(button3_spread_levels, [
					button3_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*c*/ 262144 && { content: /*c*/ ctx[18].text },
					dirty[0] & /*text_panel*/ 4096 && { menu: /*text_panel*/ ctx[12] }
				])
			: {};

			if (dirty[0] & /*theme, appliance*/ 258 | dirty[1] & /*$$scope*/ 1048576) {
				button3_changes.$$scope = { dirty, ctx };
			}

			button3.$set(button3_changes);

			const button4_changes = (dirty[0] & /*btn_props, t, shapes_panel*/ 41472)
			? get_spread_update(button4_spread_levels, [
					button4_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*t*/ 512 && { content: /*t*/ ctx[9].shapes },
					dirty[0] & /*shapes_panel*/ 8192 && { menu: /*shapes_panel*/ ctx[13] }
				])
			: {};

			if (dirty[0] & /*last_shape, theme, appliance, shape*/ 1410 | dirty[1] & /*$$scope*/ 1048576) {
				button4_changes.$$scope = { dirty, ctx };
			}

			button4.$set(button4_changes);

			const button5_changes = (dirty[0] & /*btn_props, c*/ 294912)
			? get_spread_update(button5_spread_levels, [
					button5_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*c*/ 262144 && { content: /*c*/ ctx[18].eraser }
				])
			: {};

			if (dirty[0] & /*theme, appliance*/ 258 | dirty[1] & /*$$scope*/ 1048576) {
				button5_changes.$$scope = { dirty, ctx };
			}

			button5.$set(button5_changes);

			const button6_changes = (dirty[0] & /*btn_props, t*/ 33280)
			? get_spread_update(button6_spread_levels, [
					button6_spread_levels[0],
					dirty[0] & /*btn_props*/ 32768 && get_spread_object(/*btn_props*/ ctx[15]),
					dirty[0] & /*t*/ 512 && { content: /*t*/ ctx[9].clear }
				])
			: {};

			if (dirty[0] & /*theme*/ 2 | dirty[1] & /*$$scope*/ 1048576) {
				button6_changes.$$scope = { dirty, ctx };
			}

			button6.$set(button6_changes);

			if (!/*hide_apps*/ ctx[6]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*hide_apps*/ 64) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (scrollHeight_action && is_function(scrollHeight_action.update) && dirty[0] & /*scroll_height*/ 16) scrollHeight_action.update.call(null, /*scroll_height*/ ctx[4]);

			if (!current || dirty[0] & /*scrollable*/ 32) {
				toggle_class(div0, "scrollable", /*scrollable*/ ctx[5]);
			}

			if (/*scrollable*/ ctx[5]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*scrollable*/ 32) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(t9.parentNode, t9);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			const strokewidth0_changes = {};
			if (dirty[0] & /*app*/ 1) strokewidth0_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) strokewidth0_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) strokewidth0_changes.disabled = /*disabled*/ ctx[3];
			strokewidth0.$set(strokewidth0_changes);
			const strokecolor0_changes = {};
			if (dirty[0] & /*app*/ 1) strokecolor0_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) strokecolor0_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) strokecolor0_changes.disabled = /*disabled*/ ctx[3];
			strokecolor0.$set(strokecolor0_changes);
			const textcolor_changes = {};
			if (dirty[0] & /*app*/ 1) textcolor_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) textcolor_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) textcolor_changes.disabled = /*disabled*/ ctx[3];
			textcolor.$set(textcolor_changes);
			const shapes_changes = {};
			if (dirty[0] & /*app*/ 1) shapes_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) shapes_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*language*/ 4) shapes_changes.language = /*language*/ ctx[2];
			if (dirty[0] & /*disabled*/ 8) shapes_changes.disabled = /*disabled*/ ctx[3];
			shapes.$set(shapes_changes);
			const strokewidth1_changes = {};
			if (dirty[0] & /*app*/ 1) strokewidth1_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) strokewidth1_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) strokewidth1_changes.disabled = /*disabled*/ ctx[3];
			strokewidth1.$set(strokewidth1_changes);
			const strokecolor1_changes = {};
			if (dirty[0] & /*app*/ 1) strokecolor1_changes.app = /*app*/ ctx[0];
			if (dirty[0] & /*theme*/ 2) strokecolor1_changes.theme = /*theme*/ ctx[1];
			if (dirty[0] & /*disabled*/ 8) strokecolor1_changes.disabled = /*disabled*/ ctx[3];
			strokecolor1.$set(strokecolor1_changes);

			if (dirty[0] & /*$apps, theme, $status, app*/ 1572867) {
				each_value = /*$apps*/ ctx[19];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div7, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (!current || dirty[0] & /*$apps*/ 524288) {
				set_style(div7, "--n", /*$apps*/ ctx[19].length);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(button2.$$.fragment, local);
			transition_in(button3.$$.fragment, local);
			transition_in(button4.$$.fragment, local);
			transition_in(button5.$$.fragment, local);
			transition_in(button6.$$.fragment, local);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(strokewidth0.$$.fragment, local);
			transition_in(strokecolor0.$$.fragment, local);
			transition_in(textcolor.$$.fragment, local);
			transition_in(shapes.$$.fragment, local);
			transition_in(strokewidth1.$$.fragment, local);
			transition_in(strokecolor1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(button2.$$.fragment, local);
			transition_out(button3.$$.fragment, local);
			transition_out(button4.$$.fragment, local);
			transition_out(button5.$$.fragment, local);
			transition_out(button6.$$.fragment, local);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(strokewidth0.$$.fragment, local);
			transition_out(strokecolor0.$$.fragment, local);
			transition_out(textcolor.$$.fragment, local);
			transition_out(shapes.$$.fragment, local);
			transition_out(strokewidth1.$$.fragment, local);
			transition_out(strokecolor1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div0);
			destroy_component(button0);
			destroy_component(button1);
			destroy_component(button2);
			destroy_component(button3);
			destroy_component(button4);
			destroy_component(button5);
			destroy_component(button6);
			if (if_block1) if_block1.d();
			if (detaching) detach(t8);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(t9);
			if (detaching) detach(div8);
			destroy_component(strokewidth0);
			destroy_component(strokecolor0);
			/*div2_binding*/ ctx[35](null);
			destroy_component(textcolor);
			/*div3_binding*/ ctx[36](null);
			destroy_component(shapes);
			destroy_component(strokewidth1);
			destroy_component(strokecolor1);
			/*div6_binding*/ ctx[37](null);
			destroy_each(each_blocks, detaching);
			/*div7_binding*/ ctx[39](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

const name = "fastboard-toolbar";

function instance($$self, $$props, $$invalidate) {
	let t;
	let hotkeys;
	let c;
	let memberState;
	let appliance;
	let shape;
	let status;
	let max_scroll;
	let $top;

	let $scroll_height,
		$$unsubscribe_scroll_height = noop,
		$$subscribe_scroll_height = () => ($$unsubscribe_scroll_height(), $$unsubscribe_scroll_height = subscribe(scroll_height, $$value => $$invalidate(33, $scroll_height = $$value)), scroll_height);

	let $memberState,
		$$unsubscribe_memberState = noop,
		$$subscribe_memberState = () => ($$unsubscribe_memberState(), $$unsubscribe_memberState = subscribe(memberState, $$value => $$invalidate(34, $memberState = $$value)), memberState);

	let $apps;

	let $status,
		$$unsubscribe_status = noop,
		$$subscribe_status = () => ($$unsubscribe_status(), $$unsubscribe_status = subscribe(status, $$value => $$invalidate(20, $status = $$value)), status);

	component_subscribe($$self, apps, $$value => $$invalidate(19, $apps = $$value));
	$$self.$$.on_destroy.push(() => $$unsubscribe_scroll_height());
	$$self.$$.on_destroy.push(() => $$unsubscribe_memberState());
	$$self.$$.on_destroy.push(() => $$unsubscribe_status());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { disabled = false } = $$props;
	let { scroll_height } = $$props;
	$$subscribe_scroll_height();
	let { computed_height = 0 } = $$props;
	let { scrollable = false } = $$props;
	let { hide_apps = false } = $$props;
	let last_shape = "rectangle";
	let pencil_panel;
	let text_panel;
	let shapes_panel;
	let apps_panel;
	let btn_props;
	let top = writable(0);
	component_subscribe($$self, top, value => $$invalidate(41, $top = value));

	function scroll_up() {
		set_store_value(top, $top = clamp($top - 32 - 4, 0, max_scroll), $top);
	}

	function scroll_down() {
		set_store_value(top, $top = clamp($top + 32 + 4, 0, max_scroll), $top);
	}

	function clicker() {
		app?.setAppliance("clicker");
	}

	function selector() {
		app?.setAppliance("selector");
	}

	function pencil() {
		app?.setAppliance("pencil");
	}

	function text() {
		app?.setAppliance("text");
	}

	function select_last_shape() {
		if (applianceShapes.includes(last_shape)) {
			app?.setAppliance(last_shape);
		} else {
			app?.setAppliance("shape", last_shape);
		}
	}

	function eraser() {
		app?.setAppliance("eraser");
	}

	function clear() {
		app?.cleanCurrentScene();
	}

	function div2_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			pencil_panel = $$value;
			$$invalidate(11, pencil_panel);
		});
	}

	function div3_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			text_panel = $$value;
			$$invalidate(12, text_panel);
		});
	}

	function div6_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			shapes_panel = $$value;
			$$invalidate(13, shapes_panel);
		});
	}

	const func = onClick => {
		app && onClick(app);
		tippy_hide_all();
	};

	function div7_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			apps_panel = $$value;
			$$invalidate(14, apps_panel);
		});
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(0, app = $$props.app);
		if ('theme' in $$props) $$invalidate(1, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(2, language = $$props.language);
		if ('disabled' in $$props) $$invalidate(3, disabled = $$props.disabled);
		if ('scroll_height' in $$props) $$subscribe_scroll_height($$invalidate(4, scroll_height = $$props.scroll_height));
		if ('computed_height' in $$props) $$invalidate(31, computed_height = $$props.computed_height);
		if ('scrollable' in $$props) $$invalidate(5, scrollable = $$props.scrollable);
		if ('hide_apps' in $$props) $$invalidate(6, hide_apps = $$props.hide_apps);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*theme, disabled*/ 10) {
			$: $$invalidate(15, btn_props = {
				name,
				theme,
				disabled,
				placement: "right"
			});
		}

		if ($$self.$$.dirty[0] & /*language*/ 4) {
			$: $$invalidate(9, t = i18n[language]);
		}

		if ($$self.$$.dirty[0] & /*app*/ 1) {
			$: $$invalidate(32, hotkeys = app?.hotKeys);
		}

		if ($$self.$$.dirty[0] & /*t*/ 512 | $$self.$$.dirty[1] & /*hotkeys*/ 2) {
			$: $$invalidate(18, c = {
				clicker: tooltip(t.clicker, hotkeys?.changeToClick),
				selector: tooltip(t.selector, hotkeys?.changeToSelector),
				pencil: tooltip(t.pencil, hotkeys?.changeToPencil),
				eraser: tooltip(t.eraser, hotkeys?.changeToEraser),
				text: tooltip(t.text, hotkeys?.changeToText)
			});
		}

		if ($$self.$$.dirty[0] & /*app*/ 1) {
			$: $$subscribe_memberState($$invalidate(17, memberState = app?.memberState));
		}

		if ($$self.$$.dirty[1] & /*$memberState*/ 8) {
			$: $$invalidate(8, appliance = $memberState?.currentApplianceName);
		}

		if ($$self.$$.dirty[1] & /*$memberState*/ 8) {
			$: $$invalidate(7, shape = $memberState?.shapeType);
		}

		if ($$self.$$.dirty[0] & /*app*/ 1) {
			$: $$subscribe_status($$invalidate(16, status = app?.appsStatus));
		}

		if ($$self.$$.dirty[0] & /*appliance, shape*/ 384) {
			$: if (applianceShapes.includes(appliance)) {
				$$invalidate(10, last_shape = appliance);
			} else if (shape) {
				$$invalidate(10, last_shape = shape);
			}
		}

		if ($$self.$$.dirty[0] & /*scrollable*/ 32 | $$self.$$.dirty[1] & /*$scroll_height, computed_height*/ 5) {
			$: max_scroll = scrollable
			? $scroll_height + (32 + 8) * 2 - computed_height
			: 0;
		}
	};

	return [
		app,
		theme,
		language,
		disabled,
		scroll_height,
		scrollable,
		hide_apps,
		shape,
		appliance,
		t,
		last_shape,
		pencil_panel,
		text_panel,
		shapes_panel,
		apps_panel,
		btn_props,
		status,
		memberState,
		c,
		$apps,
		$status,
		top,
		scroll_up,
		scroll_down,
		clicker,
		selector,
		pencil,
		text,
		select_last_shape,
		eraser,
		clear,
		computed_height,
		hotkeys,
		$scroll_height,
		$memberState,
		div2_binding,
		div3_binding,
		div6_binding,
		func,
		div7_binding
	];
}

class Contents extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				app: 0,
				theme: 1,
				language: 2,
				disabled: 3,
				scroll_height: 4,
				computed_height: 31,
				scrollable: 5,
				hide_apps: 6
			},
			null,
			[-1, -1]
		);
	}
}

export default Contents;